module.exports = __webpack_public_path__ + "media/images/admin/icon/icon_pen-c2574777b7de61de474ae63d9ef40082.svg";